// platformIconMapper.js

import amazon from "../../img/streaming-platform-images/amazon-music.svg";
import apple from "../../img/streaming-platform-images/apple-music.svg";
import deezer from "../../img/streaming-platform-images/Deezer.svg";
import gaana from "../../img/streaming-platform-images/gaana.svg";
import hungama from "../../img/streaming-platform-images/hungama.svg";
import jioSaavn from "../../img/streaming-platform-images/jio-saavn.svg";
import spotify from "../../img/streaming-platform-images/spotify.svg";
import youtube from "../../img/streaming-platform-images/youtube.png";
import ytMusic from "../../img/streaming-platform-images/yt-music.svg";
import instagram from "../../img/streaming-platform-images/instagram_1.svg";
import otherPlatform from "../../img/streaming-platform-images/otherPlatform.png";
import facebook from "../../img/streaming-platform-images/facebook2.png"

/**
 * Map platform name / id to icon
 */
export const getPlatformIcon = (platformName = "") => {
    const key = platformName.toLowerCase();

    if (key.includes("spotify")) return spotify;
    if (key.includes("amazon")) return amazon;
    if (key.includes("apple")) return apple;
    if (key.includes("deezer")) return deezer;
    if (key.includes("gaana")) return gaana;
    if (key.includes("hungama")) return hungama;
    if (key.includes("jio")) return jioSaavn;
    if (key.includes("youtube music")) return ytMusic;
    if (key.includes("youtube")) return youtube;
    if (key.includes("Youtube")) return youtube;
    if (key.includes("instagram")) return instagram;
    if (key.includes("Instagram")) return instagram;
    if (key.includes("Facebook")) return facebook;
    if (key.includes("facebook")) return facebook;

    return otherPlatform;
};
